import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Shortlisted from "./Shortlisted";
import TiersHeader from "./TiersHeader";
import { Button } from "antd";
import RichTextEditorModal from "./RichTextEditorModal";
import "./tiers.css"
import { generateTiers, tiersJob, getRoleData, updateShortlistedSuccess, clearShortlistedSuccess, getShortlistedSuccess } from "store/actions/tiers";
import { getInviteTimeLabel, getTemplateBtnName, isScheduled, resolveTemplateSlug } from "../../../../globalFunctions/tiers";

const Tiers = (props) => {
  const {
    shiftList,
    triggerGenerateTiers,
    triggerFetchTiers,
    triggerGetRoleData,
    triggerUpdateShortlisted,
    triggerClearShortlisted,
    loggedInUserId
  } = props;
  const [showShortlisted, setShowShortlisted] = useState(true);
  const [showTextEditor, setShowTextEditor] = useState(false);
  const [selectedRoleUUID, setSelectedRoleUUID] = useState("");
  const [initialHtml, setInitialHtml] = useState("");
  const [initialSubject, setInitialSubject] = useState("");
  const [selectedTalent, setSelectedTalent] = useState("");
  const [htmlFooter, setHtmlFooter] = useState("");
  const [selectedRolePersonUUID, setSelectedRolePersonUUID] = useState("");
  const [inviteType, setInviteType] = useState("");
  const [token, setToken] = useState("");
  const [inviteBtnName, setInviteBtnName] = useState("");
  const [emailMeta, setEmailMeta] = useState({});

  const init = () => {
    if (!selectedRoleUUID || !shiftList?.length) return;

    let peopleForRole = [];

    for (const shift of shiftList) {
      const timezone = shift.timezone;
      const tzAbbr = shift.startTZ;

      for (const role of shift.roles || []) {
        if (role.uuid === selectedRoleUUID) {
          peopleForRole = (role.people || [])
            .map(item => {
              const outStandingJob = item.outstanding_jobs?.[0] || item.completed_jobs?.[0] || null;
              const fireAfter = outStandingJob?.fire_after;
              let inviteLabel = "";
              if (outStandingJob && outStandingJob?.uuid) {
                inviteLabel = getInviteTimeLabel({
                  outStandingJob,
                  timezone,
                  tzAbbr,
                  loggedInUserId
                });
              }
              return {
                ...item.person,
                inviteStatus: item?.status,
                roleUUID: item.uuid,
                timezone: timezone,
                tzAbbr: tzAbbr,
                talentNeeded: parseInt(role.talent_needed),
                approvedStats: parseInt(role.stats?.approved),
                inviteQuotaFilled:
                  parseInt(role.talent_needed) <= parseInt(role.stats?.approved),
                inviteOfferedAt: item.offered_at,
                waitlistOfferedAt: item.waitlisted_offered_at,
                outStandingJob,
                inviteTimeLabel: inviteLabel,
                isScheduled: isScheduled(fireAfter, timezone)
              };
            })
            .filter(Boolean);

          break;
        }
      }
    }

    if (peopleForRole.length) {
      triggerUpdateShortlisted({ data: peopleForRole });
    } else {
      triggerClearShortlisted();
    }
  }

  useEffect(() => {
    init();
  }, [selectedRoleUUID, shiftList]);

  const getInviteTemplateData = async (rolePersonUUID, slug) => {
    const payload = {
      id: rolePersonUUID,
      slug: slug,
      onSuccess: (response, token) => {
        const {
          email_subject = "",
          html_body = "",
          html_footer = "",
          to_addresses,
          cc_addresses,
          bcc_addresses,
          reply_address,
          from_address,
          relationships,
        } = response || {};
        setToken(token)
        setHtmlFooter(html_footer)
        setInitialSubject(email_subject);
        setInitialHtml(html_body);
        setEmailMeta({
          to_addresses,
          cc_addresses,
          bcc_addresses,
          reply_address,
          from_address,
          relationships,
        });
        setShowTextEditor(true);
      },
      onError: () => {
        setToken("")
        setInitialHtml("")
        setInitialSubject("")
        setHtmlFooter("")
        console.error("Error while retrieving template data");
      }
    };

    triggerGetRoleData(payload);
  };

  const handleShowTextEditor = async (talent, type, rolePersonUUID) => {
    setSelectedTalent(talent);
    setInitialHtml("");

    const status = talent?.inviteStatus;

    const slug = resolveTemplateSlug(type, status);
    const btnName = getTemplateBtnName(type, status);
    setInviteBtnName(btnName)

    setSelectedRolePersonUUID(rolePersonUUID);

    if (type === "invite" || type === "inviteAll") {
      setInviteType("offered");
    } else {
      setInviteType(type);
    }

    await getInviteTemplateData(rolePersonUUID, slug);
  };

  const handleClose = async () => {
    setSelectedTalent("");
    setInitialHtml("");
    setShowTextEditor(false)
  }

  const handleRefresh = () => {
    init();
  }

  return (
    <div className="flex flex-col h-full">
      <TiersHeader setSelectedRoleUUID={setSelectedRoleUUID} />

      {showShortlisted && selectedRoleUUID && <Shortlisted displayTextEditor={handleShowTextEditor} selectedRoleUUID={selectedRoleUUID} shiftList={shiftList} handleRefresh={handleRefresh} />}

      <RichTextEditorModal
        open={showTextEditor}
        onClose={() => handleClose()}
        initialHtml={initialHtml}
        initialSubject={initialSubject}
        selectedTalent={selectedTalent}
        htmlFooter={htmlFooter}
        selectedRoleUUID={selectedRoleUUID}
        selectedRolePersonUUID={selectedRolePersonUUID}
        inviteType={inviteType}
        token={token}
        inviteBtnName={inviteBtnName}
        emailMeta={emailMeta}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    shiftList: state.shifts.shiftList,
    loggedInUserId: state.auth.loginDetails.person_uuid
  };
};

const mapDispatchToProps = {
  triggerGenerateTiers: generateTiers,
  triggerFetchTiers: tiersJob,
  triggerGetRoleData: getRoleData,
  triggerUpdateShortlisted: getShortlistedSuccess,
  triggerClearShortlisted: clearShortlistedSuccess
}

export default connect(mapStateToProps, mapDispatchToProps)(Tiers);
